import Card from './Card';
import Header from '../SharedComponents/Header';
import NavBar from '../SharedComponents/Navbar';
import './style.scss';
import { useParams } from 'react-router-dom';
export default function Similar(){
    const {id} = useParams();
    return (
        <div className="main-container" >
            <div className="similar">
                <Card />
                <Card />
                <Card />
                <Card />
            </div>
        </div>
    )
}

